import React from 'react';
import { DumbbellIcon, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-b from-black/90 to-black text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <DumbbellIcon className="h-8 w-8" />
              <span className="text-2xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">FITNESS PORTAL</span>
            </div>
            <p className="text-gray-400">
              Premium fitness experience in Grafton, Auckland
            </p>
            <div className="flex space-x-4 mt-4">
              <a 
                href="https://www.instagram.com/fitnessportal.akl/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-gradient-to-r from-blue-600/20 to-cyan-600/20 p-2 rounded-full hover:from-blue-600/30 hover:to-cyan-600/30 transition-colors"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/recovery" className="text-gray-400 hover:text-white transition-colors">Recovery</Link></li>
              <li><Link to="/classes" className="text-gray-400 hover:text-white transition-colors">Classes</Link></li>
              <li><Link to="/trainers" className="text-gray-400 hover:text-white transition-colors">Trainers</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Contact</h3>
            <ul className="space-y-2 text-gray-400">
              <li>8 Nugent Street</li>
              <li>Grafton, Auckland</li>
              <li><a href="tel:095581408" className="hover:text-blue-400 transition-colors">09 558 1408</a></li>
              <li>auckland@thefitnessportal.co.nz</li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li><Link to="/privacy-policy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-400 hover:text-white transition-colors">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Fitness Portal. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}